import React, { useState, useEffect, useCallback } from 'react';
import { PRODUCTS } from '../data/constants';
import { scrollToSection } from '../utils/scrollTo';

const SLIDES = PRODUCTS.map(p => ({ title: p.title, subtitle: p.subtitle, desc: p.desc, img: p.img, tag: p.tag }));
const INTERVAL = 5000;

const Hero: React.FC = () => {
  const [current, setCurrent] = useState(0);
  const [animKey, setAnimKey] = useState(0);

  const goTo = useCallback((idx: number) => {
    setCurrent(idx);
    setAnimKey(k => k + 1);
  }, []);

  useEffect(() => {
    const t = setInterval(() => {
      setCurrent(c => (c + 1) % SLIDES.length);
      setAnimKey(k => k + 1);
    }, INTERVAL);
    return () => clearInterval(t);
  }, []);

  return (
    <section id="hero" className="hero-slider">
      {/* Slides */}
      {SLIDES.map((slide, i) => (
        <div key={i} className={`hero-slide ${i === current ? 'active' : ''}`}>
          <img src={slide.img} alt={slide.title} className="hero-slide-bg" />
          <div className="hero-slide-overlay" />
        </div>
      ))}

      {/* Content overlay */}
      <div className="hero-slide-content">
        <div className="eyebrow" key={`eyebrow-${animKey}`} style={{ animationName: 'heroFadeUp', animationDuration: '0.7s', animationFillMode: 'both' }}>
          Our Products
        </div>
        <h1 className="hero-slide-title" key={`title-${animKey}`} style={{ animationName: 'heroFadeUp', animationDuration: '0.7s', animationDelay: '0.1s', animationFillMode: 'both' }}>
          {SLIDES[current].title}
        </h1>
        <p className="hero-slide-desc" key={`desc-${animKey}`} style={{ animationName: 'heroFadeUp', animationDuration: '0.7s', animationDelay: '0.2s', animationFillMode: 'both' }}>
          {SLIDES[current].desc}
        </p>
        <button className="btn-yellow" key={`btn-${animKey}`} style={{ animationName: 'heroFadeUp', animationDuration: '0.7s', animationDelay: '0.3s', animationFillMode: 'both' }}
          onClick={() => scrollToSection('gallery')}>
          Product Details
        </button>
      </div>

      {/* Right dot navigation */}
      <div className="hero-dots">
        {SLIDES.map((_, i) => (
          <button key={i} className={`hero-dot ${i === current ? 'active' : ''}`} onClick={() => goTo(i)} aria-label={`Slide ${i + 1}`} />
        ))}
      </div>

      {/* Bottom thumbnail strip */}
      <div className="hero-thumbs">
        {SLIDES.map((slide, i) => (
          <div key={i} className={`hero-thumb ${i === current ? 'active' : ''}`} onClick={() => goTo(i)}>
            <img src={slide.img} alt={slide.title} />
            <div className="hero-thumb-overlay" />
            <div className="hero-thumb-active-bar" key={`bar-${i === current ? animKey : 'idle'}`} />
            <div className="hero-thumb-label">
              <div className="hero-thumb-title">{slide.title}</div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes heroFadeUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </section>
  );
};
export default Hero;
